import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';

import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';
import CustomTable from '../../common/CustomTable';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
}));

export default function SupplierList(props) {
  const {
    suppliers,
    supplierNames,
    supplierIDs,
    handleSuppliersChange,
    handleStatusChange,
    statusNames,
    statusList,
    handleSearch,
    handleClear,
    selectNames,
    handleEditClick,
    rowList,
    setRowList,
    headCells,
    productsAmount,
    handleMore,
    page,
    setPage,
    handleRequestSort,
    sortProperty,
    sortDirection,
    rowsPerPage,
    setRowsPerPage,
    getFullList,
  } = props;
  const classes = useStyles();


  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  return (
    <div className={classes.root}>
      <CustomTable
        actionsLists={[statusList]}
        actionsHandleChange={[handleStatusChange]}
        actionsNames={[statusNames]}
        headCells={headCells}
        cellList={cellList}
        data={suppliers.suppliersList}
        filterIDs={supplierIDs}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEditClick={handleEditClick}
        selectNames={selectNames}
        area="supplier"
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={productsAmount}
        handleMore={handleMore}
        page={page}
        setPage={setPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullList}
      />
    </div>
  );
}
